
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{staticClass:"icon-fill",attrs:{"cx":"9","cy":"9","r":"9","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.758 11.216h-1.54a33.973 33.973 0 01-.007-.405c0-.5.083-.91.248-1.233.165-.322.496-.684.991-1.087.496-.403.792-.667.888-.792.15-.197.224-.415.224-.652a1.1 1.1 0 00-.396-.85c-.264-.235-.62-.353-1.066-.353-.431 0-.792.123-1.082.369-.29.245-.49.62-.598 1.124l-1.56-.194c.045-.72.352-1.333.922-1.837.57-.503 1.319-.755 2.245-.755.975 0 1.75.255 2.327.764.576.51.864 1.103.864 1.78 0 .375-.106.73-.318 1.063-.211.335-.663.79-1.356 1.366-.359.298-.581.538-.668.72-.086.18-.126.505-.118.972zM8.218 13.5v-1.698h1.697V13.5H8.217z","fill":"#e60000"}})])])
          )
        }
      }
    